export const Subtraction = (val1, val2) => {

  val1 = val1 * 10000;
  val2 = val2 * 10000;
  let result = val1 - val2;

  return Number((result / 10000).toFixed(2));
};

export const Addition = (val1, val2) => {
  // console.log(Number(val1), Number(val2), "val1, val2");
  val1 = Number(val1) * 10000;
  val2 = Number(val2) * 10000;
  let result = val1 + val2;
  return Number((result / 10000).toFixed(2));
};
